import styled from 'styled-components';
import { Grid, Icon } from 'semantic-ui-react';
import { colors, breakpointsNumber } from '../../styles';

export const OverviewWrapper = styled.div`
  margin: 2rem 0;
`;
export const IconContainer = styled.div`
  position: relative;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  padding: 8px;
  background: white;
  border: 1px solid ${colors.lighterGrey};
`;

export const OverviewIcon = styled(Icon)`
  position: absolute;
  left: -7px;
  top: -15px;
`;

export const TextColumn = styled(Grid.Column)`
  margin: auto;
`;

export const ContactParagraph = styled.p`
  color: ${colors.primary};
  a {
    font-weight: 600;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;

  a {
    margin-right: 1rem !important;
  }

  @media only screen and (max-width: ${breakpointsNumber.tablet - 1}px) {
    flex-direction: column;
    a {
      margin-bottom: 1rem !important;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/DealerSuccess/DealerSuccess.style.js